import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  SourceCountryState,
  SOURCE_COUNTRY_STATE,
} from './source-country.state';

export const selectSourceCountryState =
  createFeatureSelector<SourceCountryState>(SOURCE_COUNTRY_STATE);

export const selectSourceCountry = createSelector(
  selectSourceCountryState,
  (state: SourceCountryState) => {
    return state.data;
  }
);
